import { InvoiceProductInfoProps } from "./interface";


const InvoiceProductInfo:React.FC<InvoiceProductInfoProps> = ({ invoiceNumber, productIdDisplay }) => (
  <div className='d-flex flex-wrap gap-3 align-items-center mb-md-0 mb-3'>
    <div className='d-flex flex-wrap align-items-center gap-3'>
      <h2 className='mb-0 fs-14 fw-600 warranty-invoice-width'>Invoice ID :-</h2>
      <div className='id-input-design d-flex justify-content-between align-items-center gap-2'>
        <h2 className='mb-0 fs-12 fw-500'>{invoiceNumber}</h2>
        <img src={'Copy'} alt="" className='img-fluid' />
      </div>
    </div>

    <div className='d-flex flex-wrap align-items-center gap-3'>
      <h2 className='mb-0 fs-14 fw-600'>Product ID :-</h2>
      <div className='id-input-design d-flex justify-content-between align-items-center gap-2'>
        <h2 className='mb-0 fs-12 fw-500'>{productIdDisplay}</h2>
        <img src={'Copy'} alt="" className='img-fluid' />
      </div>
    </div>
  </div>
);

export default InvoiceProductInfo;
